// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"672c8088704cb780077c","655":"34ef911f912a37f5e7ff"}[chunkId] + ".js";
};